/* eslint no-multi-spaces: 0 */
/* eslint no-unused-vars : 0 */
/* eslint key-spacing    : 0 */

import Vue               from 'vue'
import axios             from 'axios'
import qs                from 'qs'
import {store}           from '@/components/store'
import endpoints         from '@/core/api/map.json'
import User              from '@/core/user'
import legacyAuth        from '@/core/legacy-auth'
import loadingIndicators from '@/core/loading-indicators'

Vue.use(loadingIndicators)

const _HTML_ = 'text/html'
const _JS_   = 'application/javascript'
const _JSON_ = 'application/json'

const backend = (response) => {
  return {
    is: (type) => response.headers['content-type'].indexOf(type) > -1,

    getError: (identifier) => {
      const el = document.createElement('html')
      const selector = identifier || '[style="color:maroon"]'

      el.innerHTML = response.data
      let query = el.querySelector(selector)
      return query ? query.innerHTML : null
    }
  }
}

export default {
  name   : 'Eved',
  getUser: User.$,

  install(Vue) {
    User.init()

    /** Set axios alias */
    Vue.prototype.$http = axios

    /** Set api instance */
    var API = axios.create({
      baseURL: process.env.NET_GATEWAY
    })

    /**
     * Set instance for endpoints that require form data
     *
     */
    API.forms = axios.create({
      baseURL: process.env.NET_GATEWAY,
      headers: {
        'Content-Type'    : 'application/x-www-form-urlencoded; charset=UTF-8',
        'Accept'          : 'application/json, text/javascript, */*',
        'X-Requested-With': 'XMLHttpRequest'
      },
      data: {},
      timeout: 30000
    })

    /** Intercept request payload and URL encode it */
    API.forms.interceptors.request.use(request => {
      // attach csrf
      request.headers['__RequestVerificationToken'] = store.state.isLoggedIn && store.state.csrf

      loadingIndicators.hook.start(request)

      request.data = qs.stringify(request.data)

      // proxy
      if (global.location.protocol === 'https:') {
        request.baseURL = request.baseURL.replace('http://local.evedonline.eved.com:8090/evednetwork', 'https://alt.dozainer.com/evedonline/dev')
      }

      return request
    })

    /**
     * Hook into api calls for handling loading indicators and notifications
     *
     */
    API.interceptors.request.use(request => {
      if (request.url !== global.app.api.$.ping) {
        loadingIndicators.hook.start(request)
      }

      // proxy
      if (global.location.protocol === 'https:') {
        request.url = request.url.replace('http://local.evedonline.eved.com:8090/api', 'https://alt.dozainer.com/evedonline-dev/api')
        request.url = request.url.replace('http://local.evedonline.eved.com:8090/evednetwork', 'https://alt.dozainer.com/evedonline/dev')
      }

      return request
    })
    API.interceptors.response.use(response => {
      loadingIndicators.hook.stop(response)

      /** If returned html, asume error */
      if (backend(response).is(_HTML_) && backend(response).getError()) {
        // Notification message
        global.app.$notifications.notify({
          type: 'warning',
          icon: 'notifications',
          message: backend(response).getError() +
            `<br><a href="#">Report this</a>`,
          timeout: 30000,
          placement: { from: 'bottom', align: 'right' }
        })
      }

      return response
    }, (error) => {
      /** Handle generic errors */
      if (error.response) {
        // Notification message
        global.app.$notifications.notify({
          type: 'plain',
          icon: 'notifications',
          message: error.response.statusText +
            `<br><a href="#">Report this</a>`,
          timeout: 30000,
          placement: { from: 'top', align: 'center' }
        })
      }

      setTimeout(() => { loadingIndicators.hook.stop() }, 3000)

      /** Handle server errors */
      if (error.response && error.response.status === 500) {
        // TODO: notify here
      } else {
        return Promise.reject(error)
      }
    })

    API.forms.interceptors.response = API.interceptors.response

    Vue.prototype.api = API
    Vue.prototype.api.$ = endpoints
    Vue.prototype.api.$.ping = process.env.PHP_GATEWAY + '/ping'
    Vue.prototype.api.$.login = process.env.PHP_GATEWAY + '/login'
    Vue.prototype.api.$.Login = process.env.NET_GATEWAY + '/Login/'
    Vue.prototype.api.$.logout = process.env.PHP_GATEWAY + '/signout'
    Vue.prototype.api.$.Logout = process.env.NET_GATEWAY + '/Account/SignOutUser'

    Vue.component(legacyAuth.name, legacyAuth)
  }
}



// WEBPACK FOOTER //
// ./src/core/api/index.js